<app-country-detail-hero [pageData]="pageData"></app-country-detail-hero>
<app-country-detail-features [pageData]="pageData"></app-country-detail-features>
<app-country-detail-other-features [pageData]="pageData"></app-country-detail-other-features>
<app-country-detail-other-countries [pageData]="pageData"></app-country-detail-other-countries>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
